/**
 * RouteTransition — 200ms cross-fade between routes.
 *
 * Wraps the Outlet content with a key tied to `location.pathname` so the
 * Fade re-mounts on every route change. Respects `prefers-reduced-motion`:
 * users with reduced motion get an instant swap.
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Fade, useMediaQuery } from '@mui/material';

const RouteTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const reduced = useMediaQuery('(prefers-reduced-motion: reduce)');
  if (reduced) return <>{children}</>;
  return (
    <Fade in key={location.pathname} timeout={200} appear>
      <div style={{ display: 'contents' }}>{children}</div>
    </Fade>
  );
};

export default RouteTransition;
